'use client'
import { formatCurrency } from '@/lib/utils';
import { Flex, Text } from '@radix-ui/themes';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import BID_ACTIONS from './BidActions';
import { AuctionState } from '@prisma/client';
import { FLASH_DURATION } from '@/lib/constants';

interface Props {
  auctionState: AuctionState;
  startBid: number;
  currentBid: number;
  started: boolean;
  expired: boolean;
  flash: boolean;
  dispatch: (action: { type: string, payload?: any }) => void;
}

const CurrentBid = ({
  auctionState,
  startBid,
  currentBid,
  started,
  expired,
  flash,
  dispatch
}: Props) => {
  useEffect(() => {
    if (flash) {
      setTimeout(() => {
        dispatch({
          type: BID_ACTIONS.UNFLASH,
        });
      }, FLASH_DURATION)
    }
  }, [flash, dispatch])

  let label;
  if (expired || auctionState === AuctionState.ARCHIVED) {
    if (started) {
      label = "Final Bid"
    } else {
      label = "Unsold"
    }
  }
  else if (started && currentBid)
    label = "Current Bid"
  else
    label = "Start Bid"

  let bid;
  if (auctionState === AuctionState.PREVIEW) { // Don't show ABFs during preview
    bid = startBid;
  } else {
    bid = currentBid;
  }

  return (
    <Flex direction="column" className="w-full">
      <Text className="text-sm uppercase text-gray-400 select-none">
        {label}
      </Text>
      <Flex justify="center" align="center" className={classNames(
        flash && "bg-gray-200",
        "transition-colors rounded-md w-fit",
      )} >
        <h2 className="select-none">{formatCurrency(bid)}</h2>
      </Flex>
    </Flex>
  )
}

export default CurrentBid
